import React from 'react';

/**
 * Lightweight inline-SVG donut chart. No external deps.
 * @param {Array<{label, value, color}>} data
 * @param {string|number} centerLabel
 * @param {string} centerSub
 */
export default function DonutChart({ data = [], centerLabel = '', centerSub = '' }) {
  const size = 128;
  const stroke = 18;
  const r = (size - stroke) / 2;
  const cx = size / 2;
  const cy = size / 2;
  const circumference = 2 * Math.PI * r;

  const total = data.reduce((a, d) => a + Math.max(0, d.value), 0);
  const hasAny = total > 0;

  let acc = 0;
  const arcs = data.map((d, i) => {
    const pct = hasAny ? d.value / total : 0;
    const dash = circumference * pct;
    const gap = circumference - dash;
    const offset = -acc;
    acc += dash;
    return (
      <circle
        key={i}
        cx={cx}
        cy={cy}
        r={r}
        fill="none"
        stroke={d.color}
        strokeWidth={stroke}
        strokeDasharray={`${dash} ${gap}`}
        strokeDashoffset={offset}
        transform={`rotate(-90 ${cx} ${cy})`}
        style={{ transition: 'stroke-dasharray .5s ease' }}
      />
    );
  });

  return (
    <svg viewBox={`0 0 ${size} ${size}`} xmlns="http://www.w3.org/2000/svg" aria-label="Income breakdown">
      <circle cx={cx} cy={cy} r={r} fill="none" stroke="#e2e8f0" strokeWidth={stroke} />
      {hasAny ? arcs : null}
      <text x={cx} y={cy - 4} textAnchor="middle" fill="#047857" fontSize="16" fontWeight="800">{centerLabel}</text>
      <text x={cx} y={cy + 14} textAnchor="middle" fill="#94a3b8" fontSize="9" letterSpacing="1">{centerSub}</text>
    </svg>
  );
}
